module.exports = __webpack_public_path__ + "static/img/1032_phase_function_Paper_PointsHejduk_Prediction.53dffae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1032_phase_function_Paper_PointsHejduk_Prediction.png
// module id = s9GE
// module chunks = 0